import { useEffect, useState } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";

const supported = () =>
  typeof window !== "undefined" && typeof window.matchMedia === "function";

/** True when the visitor has asked their OS to calm animation down. */
export default function useReducedMotion() {
  const [reduced, setReduced] = useState(
    () => supported() && window.matchMedia(QUERY).matches
  );

  useEffect(() => {
    if (!supported()) return undefined;
    const mq = window.matchMedia(QUERY);
    const onChange = (e) => setReduced(e.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  return reduced;
}
